const apiErrorMappings = {
  name: { 'value is not unique': 'Nama Pelanggan sudah terdaftar di sistem.' },
  email: { 'value is not unique': 'Email sudah terdaftar di sistem.' },
  marketing_user_id: {},
  npwp: { 'value is not unique': 'NPWP sudah terdaftar di sistem.' },
  industry_category_name: {},
  phone_number: { 'invalid phone number format': 'Nomor Telepon format tidak valid' },
  third_party_id: { 'value is not unique': 'ID Referensi sudah terdaftar di sistem.' },
}

export default apiErrorMappings
